import * as React from 'react';

import MenuIcon from '@mui/icons-material/Menu';
import { Box, IconButton } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import AstroLogoElement from '@client/components/general/AstroLogoElement';
import UserAvatarMenu from '@client/components/userAvatar/UserAvatarMenu';
import { sizes } from '@constants/sizes';

export default ({
  drawerWidth,
  handleDrawerToggle,
}: {
  drawerWidth: number;
  handleDrawerToggle: () => void;
}) => {
  return (
    <>
      <AppBar
        position='fixed'
        color='inherit'
        elevation={0}
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
          height: sizes.navBarHeight + '1px',
        }}>
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            height: '100%',
          }}>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            edge='start'
            onClick={handleDrawerToggle}
            sx={{ mr: 0, display: { md: 'none' } }}>
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            <AstroLogoElement logoVersion='full' />
          </Box>
          <Box
            sx={{
              flexGrow: { xs: 0, md: 1 },
              display: { xs: 'none', md: 'block' },
            }}
          />
          <Box>
            <UserAvatarMenu />
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};
